import React from "react";
import { ItemsView } from "@/views/items/ItemsView.tsx";

import { useCurrentList } from "@/hooks/lists.ts";

const MobileItemsPage: React.FC = () => {
	const currentList = useCurrentList(true);

	if (!currentList) {
		return null;
	}

	return (
		<main className={"w-full"}>
			<div className={"flex justify-center flex-1"}>
				<div className={"w-full max-w-[800px] px-4 pt-4"}>
					<ItemsView listId={currentList.id} />
				</div>
			</div>
		</main>
	);
};

export { MobileItemsPage };
